import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-dialog-actions',
  templateUrl: './dialog-actions.component.html',
  styleUrl: './dialog-actions.component.scss',
})
export class DialogActionsComponent {
  /** Keep the actions on ONE line at phone widths too (short Cancel/Save
   *  pairs) instead of the default stacked full-width mobile layout. */
  @Input() inline = false;
}
